import { useState, useMemo, useEffect } from "react";
import { useParams } from "react-router";
import { useRootStore } from "store";
import { InboxType } from "models/inbox/inbox";
import ThreadSidebarList from "views/inbox/components/Inbox/sidebar/threadSidebarList";
import MessageSidebarList from "views/inbox/components/Inbox/sidebar/messageSiedebarList";
import { Loader } from "components/loader/Loader";

import "./index.scss";
import "./inboxSidebarContent.scss";

export default function InboxSidebarContent() {
  const { inboxType } = useParams<{ inboxType: InboxType }>();
  const [shouldScroll, setShouldScroll] = useState(false);

  const {
    myThreads,
    allThreads,
    sentMessages,
    sentMessagesSearchTerm,
    isLoadingAllThreads,
    isLoadingMyThreads,
    isLoadingSentMessages
  } = useRootStore((state) => state.inbox);

  const { isLoadingArchiveRoot } = useRootStore((s) => s.archive);

  // Filter sent messages based on search term
  const filteredSentMessages = useMemo(() => {
    if (!sentMessagesSearchTerm || sentMessagesSearchTerm.trim() === "") {
      return sentMessages;
    }

    const searchLower = sentMessagesSearchTerm.toLowerCase();
    return sentMessages.filter((message) => {
      const bodyMatch = message.body?.toLowerCase().includes(searchLower);
      const senderMatch = message.formatedFrom
        ?.toLowerCase()
        .includes(searchLower);
      return bodyMatch || senderMatch;
    });
  }, [sentMessages, sentMessagesSearchTerm]);

  useEffect(() => {
    setShouldScroll(false);
  }, [inboxType]);

  const isLoading =
    isLoadingMyThreads ||
    isLoadingAllThreads ||
    isLoadingSentMessages ||
    isLoadingArchiveRoot;

  if (isLoading) {
    return <Loader className="mt-3" />;
  }

  return (
     <div className="threadContainer">

      {(inboxType === "my" || inboxType === "new") && (
        <ThreadSidebarList
          threads={myThreads}
          type="my"
          shouldScroll={shouldScroll}
          setShouldScroll={setShouldScroll}
        />
      )}

      {inboxType === "all" && (
        <ThreadSidebarList
          threads={allThreads}
          type="all"
          shouldScroll={shouldScroll}
          setShouldScroll={setShouldScroll}
        />
      )}

      {inboxType === "sent" && (
        <MessageSidebarList messages={filteredSentMessages} />
      )}
      </div>

      
  );
}
